import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export interface FlightExplorerIconProps {
  colour: string;
  height?: number;
  width?: number;
  viewBox?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
}

export const FlightExplorerIcon: React.FC<FlightExplorerIconProps> = ({
  colour = '#1890FF',
  height,
  width,
  viewBox,
  style,
  onClick
}) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={viewBox}
      fill="none"
      onClick={onClick}
      style={style}
    >
      <path
        d="M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z"
        fill={colour}
      />
      <path
        d="M12.6457 8.77345L7.44082 4.99414C7.39908 4.96354 7.34966 4.94513 7.29807 4.94097C7.24647 4.93681 7.19474 4.94705 7.14863 4.97056C7.10252 4.99407 7.06384 5.02993 7.03691 5.07413C7.00998 5.11833 6.99585 5.16914 6.9961 5.2209V12.7795C6.9961 13.0098 7.25625 13.1399 7.44082 13.0063L12.6457 9.22696C12.6816 9.20107 12.7109 9.16701 12.7311 9.12758C12.7513 9.08816 12.7618 9.0445 12.7618 9.00021C12.7618 8.95591 12.7513 8.91225 12.7311 8.87283C12.7109 8.8334 12.6816 8.79934 12.6457 8.77345ZM8.11758 11.1289V6.87149L11.0479 9.00021L8.11758 11.1289Z"
        fill={colour}
      />
    </SvgIcon>
  );
};
